<template>
  <div
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed"
  >
    <div class="modal-inner align-items-center justify-content-center d-flex">
      <div
        class="bm-image-modal-content bg-white px-24 pt-24 pb-26 position-fixed rounded rounded-4 scroller w-100 h-100"
      >
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon"
          @click="closeModal"
        >
          <icon name="close-icon" />
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-24 mb-0">Add Video</h2>
          <div class="tabs-wrapper">
            <div class="tabs-inner">
              <ul class="list-unstyled display-grid mb-0 mt-18">
                <li>
                  <tab
                    :id="3"
                    :tab-active="selectedId"
                    title="Stock videos"
                    @click="selectedId = '3'"
                  />
                </li>

                <li class="">
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"
                    @click="selectedId = '2'"
                  />
                </li>
                <li class="">
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"
                    @click="selectedId = '1'"
                  />
                </li>
              </ul>
            </div>

            <div class="main-tabs-content mt-20">
              <div v-if="selectedId == 1">
                <div class="text-center">Coming Soon...</div>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select px-16">
                <video-file-select/>
                <!-- <file-select class="px-16" /> -->
              </div>
              <div v-if="selectedId == 3">
                <!-- <div class="text-center">Coming Soon...</div> -->
                <stock-video-box/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="$store.commit('setDisplayAddVideoModal', false) && this.$store.commit('setIsVideoModel', false);"
    />
  </div>
</template>

<script>
import Tab from '@/components/Tab/Tab';
import EventBus from '../../EventBus';
import VideoFileSelect from '../VideoFileSelect/VideoFileSelect';
import StockVideoBox from '../StockVideoBox/StockVideoBox';

export default {
  components: {
    tab:                 Tab,
    'video-file-select': VideoFileSelect,
    'stock-video-box':   StockVideoBox,
  },
  data() {
    return {
      selectedId: '3',
    };
  },
  mounted() {
    EventBus.$on('toggleTabs', this.handleTabClick);
    EventBus.$on('AddNewVideoOnCanvas', this.onAddNewVideoOnCanvas);
  },
  beforeDestroy() {
    EventBus.$off('toggleTabs', this.handleTabClick);
    EventBus.$off('AddNewVideoOnCanvas', this.onAddNewVideoOnCanvas);
  },
  methods: {
    handleTabClick(id) {
      this.selectedId = id;
    },
    onAddNewVideoOnCanvas(videoData) {
      console.log(videoData);
      // EventBus.$emit('onAddingNewObjectVideo', videoData);// onAddingNewObjectImage
    },
    closeModal() {
      EventBus.$emit('abortVideoUpload');
      this.$store.commit('setDisplayAddVideoModal', false);
      this.$store.commit('setIsVideoModel', false);
    },
  },
};
</script>

<style></style>
